import React, { Component } from 'react'
import { Row, Col, Alert, Button, Table } from 'antd'
import moment from 'moment'
import AuthModel from '../models/AuthModel'

const dateFormat = 'YYYY/MM/DD HH:mm'

class IssueStep4 extends Component {

    render() {

        // New attachments
        var attachments = []
        const newAttachColumns = [
        {
            title: 'Tipo',
            dataIndex: 'description',
            key: 'description'
        },
        {
            title: 'Nome',
            dataIndex: 'name',
            key: 'name'
        }]
        attachments = this.props.newAttach.map((item) => {
            item.key = item.uid
            return item
        })
        this.props.attachments.forEach((item) => {
            item.key = item.id
            item.name = item.descricao
            item.description = item.tipo_ficheiro_id === 1 ? 'Fotografia'
                : (item.tipo_ficheiro_id === 2 ? 'Levantamento topográfico' : 'Outro')
            attachments.push(item)
        })
        return (
            <div className={this.props.className}>

                <Row>
                    <Col xs={24} sm={6}></Col>
                    <Col xs={24} sm={14}><legend>Resumo da Ocorrência</legend></Col>
                </Row>

                <Row>
                    <Col xs={24} sm={6}></Col>
                    <Col xs={24} sm={14}>

                        <table style={{textAlign: 'left', verticalAlign: 'top'}}>
                            <tbody>
                                <tr>
                                    <th style={{minWidth: '120px'}}>Tipo de Deteção</th>
                                    <td>{this.props.issue_detection === 1 ? 'Aviso/Chamada': 'Visita Regular'}</td>
                                </tr>
                                <tr>
                                    <th>Local</th><td>{this.props.address}</td>
                                </tr>
                                <tr>
                                    <th>Praia</th><td>{this.props.praia}</td>
                                </tr>
                                <tr>
                                    <th>Freguesia</th><td>{this.props.freguesia}</td>
                                </tr>
                                <tr>
                                    <th>Concelho</th><td>{this.props.concelho}</td>
                                </tr>
                                <tr>
                                    <th>Distrito</th><td>{this.props.distrito}</td>
                                </tr>
                                <tr>
                                    <th>ARH</th><td>{this.props.arh}</td>
                                </tr>
                                <tr>
                                    <th>Data da Ocorrência</th>
                                    { this.props.data_ocorrencia_tipo === 0 ? (
                                      <td>{moment(this.props.issue_date + ' ' + this.props.issue_time, 'YYYY/MM/DD HH:mm').format(dateFormat)}</td>
                                    ) : (
                                        <td><em>Indeterminada</em></td>
                                    )}
                                </tr>
                                <tr>
                                    <th>Data do Registo</th>
                                    <td>{moment(this.props.issue_reg_local_date + ' ' + this.props.issue_reg_local_time, 'YYYY/MM/DD HH:mm').format(dateFormat)}</td>
                                </tr>

                                { this.props.id ? (
                                    <tr>
                                        <th>Data do Registo no Sistema</th><td>{moment(this.props.data_registo).format(dateFormat)}</td>
                                    </tr>
                                ) : null}

                                { this.props.user.indexOf('public_') === -1 ? (
                                    <tr>
                                        <th>Utilizador</th><td>{this.props.user}</td>
                                    </tr>
                                ) : null}

                                { this.props.user.indexOf('public_') === -1 ? (
                                    <tr>
                                        <th>Entidade</th><td>{this.props.entidade}</td>
                                    </tr>
                                ) : null}

                                <tr>
                                    { this.props.type_a ? (<th>a. Instabilidade em arribas</th>) : null }
                                    { this.props.type_a ? (
                                        <td>
                                            { this.props.type_ai ? (
                                                <p>i. Movimento de massa de vertente (MMV)<br />Alcance máximo do depósito/detritos: {this.props.type_ai_meters} metros</p>
                                            ) : null}
                                            { this.props.type_aii ? (
                                                <p>ii. Fenda de tração com cobertura visivel: Sim</p>
                                            ) : null}
                                        </td>
                                    ) : null }
                                </tr>
                                <tr>
                                    { this.props.type_b ? (<th>b. Erosão/recuo da linha de costa</th>) : null }
                                    { this.props.type_b ? (
                                        <td>
                                            { this.props.type_bi ? (
                                                <p>i. Escarpamento da duna<br />Altura máxima da escarpa: {this.props.type_bi_meters} metros</p>
                                            ) : null}
                                            { this.props.type_bii ? (
                                                <p>ii. Rebaxamento da praia<br />Altura máxima: {this.props.type_bii_meters} metros</p>
                                            ) : null}
                                        </td>
                                    ) : null }
                                </tr>
                                <tr>
                                    { this.props.type_c ? (<th>c. Dano em obra/estrutura de proteção costeira</th>) : null }
                                    { this.props.type_c ? (<td>Sim</td>) : null }
                                </tr>
                                <tr>
                                    { this.props.type_d ? (<th>d. Galgamento costeiro</th>) : null }
                                    { this.props.type_d ? (
                                        <td>Alcance máximo da água/detritos: {this.props.type_d_meters} metros</td>
                                    ) : null }
                                </tr>
                                <tr>
                                    <th>a. Pessoas em risco</th>
                                    { this.props.cons_a === '1' ? (<td>i. Não</td>) : null}
                                    { this.props.cons_a === '2' ? (<td>ii. Não sabe / Não aplicável</td>) : null}
                                    { this.props.cons_a === '3' ? (
                                        <td>iii. Sim, quantidade:{' '}
                                            { this.props.cons_aiii_qtt === 1 ? '1-10'
                                                : (this.props.cons_aiii_qtt === 2 ? '10-100' : '> 100')
                                            }
                                        </td>
                                    ) : null }
                                </tr>

                                { this.props.cons_bii || this.props.cons_biii || this.props.cons_biv || this.props.cons_bv ? (
                                    <tr>
                                        <th>b. Danos em infra-estruturas</th>
                                        <td>
                                            { this.props.cons_bi ? (<p>i. Não</p>) : null}
                                            { this.props.cons_bii ? (
                                                <p>ii. Sim{' '}
                                                    { this.props.cons_bii1 ? '1. Estrutura aderente ' : null }
                                                    { this.props.cons_bii2 ? '2. Esporão/quebra-mar ' : null }
                                                    { this.props.cons_bii3 ? '3. Obra de proteção/estabilização de Arriba' : null }
                                                </p>
                                            ) : null }
                                            { this.props.cons_biii ? (<p>iii. Áreas construídas de fruição/uso público (e.g. passeio pedonal/passadiços/miradouro/zonas estadia)</p>) : null }
                                            { this.props.cons_biv ? (<p>iv. Edificações (e.g. habitações/comerciais/apoios de praia)</p>) : null }
                                            { this.props.cons_bv ? (<p>v. Outras</p>) : null }
                                        </td>
                                    </tr>
                                ) : (
                                    <tr>
                                        <th>b. Danos em infra-estruturas</th>
                                        <td>i. Não</td>
                                    </tr>
                                ) }

                                <tr>
                                    <th>Medidas de mitigação ou minimização do risco</th>
                                    <td>
                                        { this.props.miti === '1' ? (<p>i. Não</p>) : null}
                                        { this.props.miti === '2' ? (<p>ii. Não sabe / Não aplicável</p>) : null}
                                        { this.props.miti === '3' ? (
                                            <div>
                                                <p>iii. Sim</p>
                                                { this.props.miti_c_i ?
                                                    (<p>i. Sinalização (aviso/interdição) {this.props.miti_c_i === 'i' ? ' - Imediata' : ' - A adotar' }</p>)
                                                    : null
                                                }
                                                { this.props.miti_c_ii ?
                                                    (<p>ii. Delimitação/interdição de área de risco {this.props.miti_c_ii === 'i' ? ' - Imediata' : ' - A adotar' }</p>)
                                                    : null
                                                }
                                                { this.props.miti_c_iii ?
                                                    (<p>iii. Saneamento de blocos/reperfilamento {this.props.miti_c_iii === 'i' ? ' - Imediata' : ' - A adotar' }</p>)
                                                    : null
                                                }
                                                { this.props.miti_c_iv ?
                                                    (<p>iv. Reabilitação de obra de proteção/estabilização {this.props.miti_c_iv === 'i' ? ' - Imediata' : ' - A adotar' }</p>)
                                                    : null
                                                }
                                                { this.props.miti_c_v ?
                                                    (<p>v. Reforço/Alimentação artificial de emergência {this.props.miti_c_v === 'i' ? ' - Imediata' : ' - A adotar' }</p>)
                                                    : null
                                                }
                                            </div>
                                        ) : null }
                                    </td>
                                </tr>

                                { this.props.obs ? (
                                    <tr>
                                        <th>Observações</th>
                                        <td>{this.props.obs}</td>
                                    </tr>
                                ) : null }

                            </tbody>
                        </table>

                        <legend style={{marginTop: '20px'}}>Anexos</legend>
                        <Table dataSource={attachments} columns={newAttachColumns} />

                        { !this.props.submitdate ? (
                            <div style={{borderTop: '2px solid gray', marginTop: '16px', paddingTop: '8px'}}>
                                { AuthModel.isAuthenticated() ? (
                                    <Button onClick={(e) => this.props.onSaveForm()}
                                        disabled={!this.props.loading}>
                                        <span className="hide-small">Guardar</span>
                                        <i className="anticon anticon-save"></i>
                                    </Button>
                                ) : null }
                                {' '}
                                <Button type="danger" onClick={(e) => this.props.history.push('/')}>
                                    <span className="hide-small">Cancelar</span>
                                    <i className="anticon anticon-close"></i>
                                </Button>
                                {' '}
                                { this.props.status !== 'Submetida' ? (
                                    <Button style={{float: 'right'}} type="primary"
                                        disabled={!this.props.loading}
                                        onClick={(e) => this.props.onSubmit()}>
                                        Submeter
                                        <i className="anticon anticon-right"></i>
                                    </Button>
                                ) : null }
                            </div>
                        ) : (
                            <div style={{borderTop: '2px solid gray', marginTop: '16px', paddingTop: '8px'}}>
                                { AuthModel.isAuthenticated() ? (
                                    <Button onClick={(e) => this.props.onSaveForm()}
                                        disabled={!this.props.loading}>
                                        <span className="hide-small">Guardar</span>
                                        <i className="anticon anticon-save"></i>
                                    </Button>
                                ) : null }
                                {' '}
                                <Button type="danger" onClick={(e) => this.props.history.push('/')}>
                                    <span className="hide-small">Cancelar</span>
                                    <i className="anticon anticon-close"></i>
                                </Button>
                                {' '}
                            </div>
                        ) }

                        <Alert style={{display: this.props.complete && !this.props.error ? 'block' : 'none', marginTop: '20px' }}
                            message="Sucesso!"
                            description={'A ocorrência foi guardada.' + (this.props.status !== 'Submetida' ? ' Para enviar definitivamente clique em Submeter.' : '')}
                            type="success"
                            showIcon
                        />

                        <Alert style={{display: this.props.complete && this.props.error ? 'block' : 'none', marginTop: '20px' }}
                            message="Erro"
                            description={'Ocorreu um erro ao registar a ocorrência: ' + this.props.error}
                            type="error"
                            showIcon
                        />

                    </Col>
                </Row>

            </div>
        )
    }
}

export default IssueStep4;



// WEBPACK FOOTER //
// ./src/components/IssueStep4.js